import root from '@/router/middleware/root'

import CatalogIndex from '@/views/catalog'
import catalog from '@/views/catalog/Catalog.vue'
import catalogItem from '@/views/catalog/Item.vue'
import catalogApplication from '@/views/catalog/Application.vue'

const routes = {
    path: '/catalog',
    name: 'catalog',
    component: CatalogIndex,
    meta: {
        middleware: [root]
    },
    children: [
        {
            path: '',
            name: 'catalog.list',
            component: catalog,
            meta: {
                fullWidth: true,
                middleware: [root]
            }
        },
        {
            path: 'application',
            name: 'catalog.application',
            component: catalogApplication,
            meta: {
                // fullWidth: true,
                middleware: [root]
            }
        },
        {
            path: ':id',
            name: 'catalog.item',
            component: catalogItem,
            meta: {
                fullWidth: true,
                middleware: [root]
            }
        }
    ]
}

export default routes
